{
  "login": {
    "title": "Anmelden",
    "subtitle": "Geben Sie Ihre Zugangsdaten ein",
    "email": "E-Mail",
    "password": "Passwort",
    "submit": "Anmelden",
    "googleSignIn": "Mit Google anmelden",
    "noAccount": "Noch kein Konto?",
    "signUpLink": "Registrieren",
    "signUpTitle": "Registrieren",
    "signUpSubtitle": "Neues Konto erstellen",
    "signUpSubmit": "Registrieren",
    "hasAccount": "Bereits ein Konto?",
    "signInLink": "Anmelden",
    "invalidCredentials": "Ungültige E-Mail oder Passwort",
    "error": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut."
  },
  "common": {
    "welcome": "Willkommen, {name}!",
    "loading": "Lädt...",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "error": "Fehler",
    "success": "Erfolg"
  },
  "panel": {
    "header": "Rollendetails",
    "placeholder": "Klicken Sie auf eine Rolle, um Details anzuzeigen",
    "successMessage": "Unterrolle erstellt! Wird aktualisiert...",
    "details": {
      "purpose": "Sinn",
      "accountabilities": "Verantwortlichkeiten",
      "responsibilities": "Zuständigkeiten",
      "value": "Wert",
      "noPurpose": "Kein Sinn definiert",
      "noAccountabilities": "Keine Verantwortlichkeiten definiert",
      "noResponsibilities": "Keine Zuständigkeiten definiert"
    },
    "tabs": {
      "details": "Rolle",
      "people": "Personen",
      "contained": "Enthalten",
      "referenced": "Referenziert"
    },
    "edit": {
      "enterEditMode": "Bearbeiten",
      "saveChanges": "Änderungen speichern",
      "cancelChanges": "Abbrechen",
      "saveHint": "Änderungen werden beim Verlassen gespeichert",
      "enterToSave": "Enter drücken zum Speichern",
      "saveOnChange": "Speichert bei Änderung"
    },
    "claim": {
      "claim": "Rolle beanspruchen",
      "unclaim": "Freigeben",
      "claimedBy": "Von Ihnen beansprucht"
    },
    "create": {
      "addChild": "Untergeordnete Rolle hinzufügen",
      "roleName": "Rollenname",
      "create": "Erstellen",
      "childName": "Name der Unterrolle",
      "size": "Größe",
      "color": "Farbe",
      "createButton": "Unterrolle erstellen",
      "creating": "Wird erstellt..."
    },
    "delete": {
      "deleteRole": "Rolle löschen",
      "confirmDelete": "Sind Sie sicher, dass Sie diese Rolle löschen möchten?",
      "hasChildren": "Diese Rolle enthält {count} untergeordnete Rollen. Diese werden ebenfalls gelöscht."
    },
    "people": {
      "label": "Personen in dieser Rolle",
      "noClaims": "Niemand hat diese Rolle bisher beansprucht",
      "since": "seit {date}",
      "first": "zuerst: {date}",
      "current": "aktuell: {date}"
    },
    "referenced": {
      "label": "Referenziert von",
      "none": "Keine Rollen referenzieren diese Rolle"
    },
    "contained": {
      "label": "Enthaltene Rollen",
      "none": "Keine enthaltenen Rollen",
      "children": "Unterrollen"
    },
    "actions": {
      "viewMode": "← Ansichtsmodus",
      "myRoles": "← Meine Rollen"
    }
  },
  "search": {
    "placeholder": "Rollen suchen...",
    "noResults": "Keine Rollen gefunden für \"{query}\"",
    "showMyRoles": "Meine Rollen anzeigen",
    "showAllRoles": "Alle Rollen anzeigen"
  },
  "settings": {
    "title": "Einstellungen",
    "selectLanguage": "Sprache wählen",
    "language": "Sprache",
    "theme": "Design",
    "lightMode": "Hell",
    "darkMode": "Dunkel"
  },
  "main": {
    "showMyRoles": "Meine Rollen anzeigen",
    "hideMyRoles": "Meine Rollen ausblenden"
  },
  "hover": {
    "noPurpose": "Kein Sinn",
    "accountabilities": "Verantwortlichkeiten",
    "responsibilities": "Zuständigkeiten",
    "none": "Keine"
  },
  "legend": {    "toggleButton": "Legende",    "noCustomColors": "Keine benutzerdefinierten Farben zugewiesen",
    "showRolesWithData": "Rollen mit Daten anzeigen",
    "impressum": "Impressum",
    "privacy": "Datenschutzerklärung"
  },
  "errors": {
    "updateFailed": "Aktualisierung fehlgeschlagen",
    "createFailed": "Fehler beim Erstellen",
    "deleteFailed": "Löschen fehlgeschlagen",
    "saveFailed": "Speicherfehler",
    "cannotDelete": "Kann nicht gelöscht werden",
    "cannotDeleteMessage": "\"{name}\" kann nicht gelöscht werden, da es untergeordnete Rollen enthält.{childList}\n\nBitte löschen oder verschieben Sie zuerst die untergeordneten Rollen.",
    "confirmDelete": "Möchten Sie \"{name}\" wirklich löschen?",
    "invalidInput": "Ungültige Eingabe",
    "pleaseEnterName": "Bitte geben Sie einen Rollennamen ein",
    "creationFailed": "Erstellung fehlgeschlagen",
    "createChildFailed": "Untergeordnete Rolle konnte nicht erstellt werden",
    "unknownError": "Unbekannter Fehler",
    "childRolesList": "\n\nUntergeordnete Rollen:\n• {children}",
    "referencedBy": "Referenziert von:\n• {references}"
  },
  "myRoles": {
    "title": "Meine Rollen",
    "noClaims": "Sie haben noch keine Rollen beansprucht.",
    "loadingDetails": "Rollendetails werden geladen..."
  },
  "toast": {
    "roleDeleted": "Rolle gelöscht",
    "roleSaved": "Änderungen gespeichert",
    "roleCreated": "Rolle erstellt"
  }
}
